import { ProductProps } from "../../types/productTypes";

const parseProductPrice = (price?: string | null): number => {
  if (!price) {
    return Number.POSITIVE_INFINITY;
  }

  const cleaned = price
    .replace(/&[a-zA-Z]+;/g, " ")
    .replace(/[^\d.,-]/g, " ")
    .trim();
  const match = cleaned.match(/-?\d+(?:[.,]\d+)?/);

  if (!match) {
    return Number.POSITIVE_INFINITY;
  }

  return parseFloat(match[0].replace(",", "."));
};

const getEffectivePrice = (product: ProductProps): number => {
  if (product.onSale && product.salePrice) {
    return parseProductPrice(product.salePrice);
  }

  return parseProductPrice(product.regularPrice || product.salePrice);
};

/**
 * Client-side product sorting.
 * The GraphQL API currently ignores `where.orderby`, so PRICE/SLUG must be applied locally.
 */
export const sortProducts = (
  products: ProductProps[] | undefined | null,
  field: string,
  order: string
): ProductProps[] => {
  if (!products?.length) {
    return products ?? [];
  }

  const direction = order === "DESC" ? -1 : 1;
  const sorted = [...products];

  if (field === "PRICE") {
    sorted.sort(
      (a, b) => (getEffectivePrice(a) - getEffectivePrice(b)) * direction
    );
  } else if (field === "SLUG") {
    sorted.sort((a, b) => {
      const aSlug = (a.slug || a.name || "").toLowerCase();
      const bSlug = (b.slug || b.name || "").toLowerCase();
      return aSlug.localeCompare(bSlug) * direction;
    });
  }

  return sorted;
};
